module.exports = __webpack_public_path__ + "img/governance.86cd3dd7.jpg";